(function(angular, _) {
    'use strict';

    angular.module('GorillaBoy.FileBrowser')
    .controller('FilesRightPanelController', ['$scope', FilesRightPanelController]);

    function FilesRightPanelController($scope) {
        
    }
}(angular, _));